import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetAuthorizationsOdontoTrack,
	AuthorizationsOdontoTrackModel,
	AuthorizationsOdontoTrackParams,
} from 'domain/usecases/private/authorizations/get-authorizations-odonto-track';

export class RemoteGetAuthorizationsOdontoTrack implements GetAuthorizationsOdontoTrack {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<AuthorizationsOdontoTrackModel>,
	) {}

	async get({
		signal,
		...params
	}: AuthorizationsOdontoTrackParams): Promise<AuthorizationsOdontoTrackModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
